/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { Observable, Subscription } from 'rxjs';
import { MtmaCloneFlag } from 'src/app/model/mtma-module';
import { isMtmacModel } from 'src/app/conf/device-models';
import { filter } from 'rxjs/operators';
import { DevicesTree } from 'src/app/model/device-tree';
import { StandardDynamicComponent, StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { Site } from 'src/app/model/site';
import { selectCloneMtmaRunning, selectMtmaCloneModify } from 'src/app/store/device/device.selector';
import { selectIsImpersMode } from 'src/app/store/user/user.selector';

@Component({
	selector: 'app-mtma-clone-dialog',
	templateUrl: './mtma-clone-dialog.component.html',
})

export class MtmaCloneDialogComponent implements OnInit, OnDestroy {
	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;
	mtmaCloneModify$: Observable<boolean | undefined>;
	mtmaCloneModifySub: Subscription | undefined;
	mtmaCloneMtmaRunning$: Observable<boolean | undefined>;
	mtmaCloneMtmaRunningSub: Subscription | undefined;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;

	deviceId: number;
	isImpersMode: boolean;

	cloneForm: FormGroup;

	deviceInfoSub: Subscription;
	mtmaRuleModifySub: Subscription;

	listOtherMtma: DevicesTree[];

	mtmaCloneSub: Subscription;

	saving: boolean;


	// design
	screenWidth: number;

	constructor(
		private fb: FormBuilder,
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		if (config.data !== undefined && config.data.deviceId !== undefined) {
			this.deviceId = config.data.deviceId;
		}
		this.initSelectors();
	}

	initSelectors(): void {
		this.site$ = this.store.select(selectCurrentSite);
		this.mtmaCloneModify$ = this.store.select(selectMtmaCloneModify);
		this.mtmaCloneMtmaRunning$ = this.store.select(selectCloneMtmaRunning);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
	}

	ngOnInit(): void {
		this.cloneForm = this.fb.group({
			deviceIdTo: ['', [Validators.required]],
		});
		this.siteSub = this.site$.pipe(filter(site => !!site))
			.subscribe(currentSite => {
				this.listOtherMtma = currentSite.DevicesTree.Children.filter(device => isMtmacModel(device.ModelId) && device.Id !== this.deviceId);
			});


		this.mtmaCloneSub = this.mtmaCloneModify$.subscribe((flag) => {
			if (flag) {
				this.resetClose();
			}
		});
		this.mtmaCloneMtmaRunningSub = this.mtmaCloneMtmaRunning$.subscribe((saving) => {
			this.saving = saving;
		});
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	ngOnDestroy(): void {
		this.deviceInfoSub?.unsubscribe();
		this.siteSub?.unsubscribe();
		this.mtmaCloneModifySub?.unsubscribe();
		this.mtmaCloneMtmaRunningSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
	}

	resetClose(): void {
		this.store.dispatch(DeviceActions.resetCloneMtmaForm());
		this.closeDialog();
	}

	submit(): void {
		const flag = new MtmaCloneFlag();
		flag.Automation = true;
		flag.ContactsUnits = true;
		flag.Dtmfs = true;
		flag.Keypads = true;
		flag.Modules = true;
		flag.RulesAccess = true;
		flag.Tags = true;
		this.store.dispatch(DeviceActions.cloneMtma({ deviceIdFrom: this.deviceId, deviceIdTo: this.cloneForm.value.deviceIdTo, flags: flag, isImpersMode: this.isImpersMode }));
	}

	get f(): any {
		return this.cloneForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: MtmaCloneDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: MtmaCloneDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	dynamicDatepicker(): string {
		return StandardDynamicComponent.dynamicDatepicker(this.screenWidth);
	}

	dynamicInputTextDesktopTabletWidth(): string {
		return StandardPageLayout.dynamicInputTextDesktopTabletWidth(this.screenWidth, 'w-20rem', 'w-30rem');
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

}
